import { Box } from '@mantine/core'
import { Document } from 'iconsax-reactjs'

type Props = {
  title: string
  iconUrl?: string
  color: string
  size?: number
}

export const getIcon = ({ title, iconUrl, color, size = 22 }: Props) => {
  return iconUrl ? (
    <Box
      w={size}
      h={size}
      role="img"
      aria-label={title}
      style={{
        backgroundColor: color,
        WebkitMaskImage: `url(${iconUrl})`,
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        WebkitMaskSize: 'contain',
        maskImage: `url(${iconUrl})`,
        maskRepeat: 'no-repeat',
        maskPosition: 'center',
        maskSize: 'contain'
      }}
    />
  ) : (
    <Document />
  )
}
